export const GRAD_FAIR_NAME_MAP = {
  /* 2019 */
  NYC: 'New York',
  BOS: 'Boston',
  PHL: 'Philadelphia',
  WDC: 'Washington, DC',
  MSP: 'Minneapolis',
  CHI: 'Chicago',
  LAX: 'Los Angeles',
  SFO: 'San Francisco',
  SEA: 'Seattle',
  ATL: 'Atlanta',
  /* virtual (2020) */
  NE1: 'September 10',
  NE2: 'September 29',
  NE3: 'October 20',
  SO1: 'September 17',
  SO2: 'September 30',
  SO3: 'October 16',
  MW1: 'September 15',
  MW2: 'October 5',
  WE1: 'September 23',
  WE2: 'October 8',
  NW1: 'September 25',
  NW2: 'October 14',
  /* test locations */
  SF: 'San Francisco',
  LOC1: 'Location One',
  LOC2: 'Location Two',
  LOC3: 'Location Three',
  LOC4: 'Location Four',
  LOC5: 'Location Five',
  LOC6: 'Location Six',
  LOC7: 'Location Seven',
  LOCU1: 'Location Unlimited One',
  LOCU2: 'Location Unlimited Two',
  LOCU3: 'Location Unlimited Three',
  FAIR_APP_CITY: 'Fair App City',
  FAIR_APP_CITY_2: 'Fair App Town'
};

export const GRAD_FAIRS = [
  {
    id: 'NE1',
    date: '2020-09-10T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/458Rw'
  },
  {
    id: 'MW1',
    date: '2020-09-15T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/GjmkW'
  },
  {
    id: 'SO1',
    date: '2020-09-17T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/437lN'
  },
  {
    id: 'WE1',
    date: '2020-09-23T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/agx10'
  },
  {
    id: 'NW1',
    date: '2020-09-25T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/4AxDm'
  },
  {
    id: 'NE2',
    date: '2020-09-29T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/aePxz'
  },
  {
    id: 'SO2',
    date: '2020-09-30T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/XB9k5'
  },
  {
    id: 'MW2',
    date: '2020-10-05T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/a7lYA'
  },
  {
    id: 'WE2',
    date: '2020-10-08T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/4qKLB'
  },
  {
    id: 'NW2',
    date: '2020-10-14T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/48Npn'
  },
  {
    id: 'SO3',
    date: '2020-10-16T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/XbM6x'
  },
  {
    id: 'NE3',
    date: '2020-10-20T17:00:00-04:00',
    url: 'https://app.brazenconnect.com/events/GlkdM'
  }
];
